import '@angular/compiler';
import 'bootstrap';
import * as FileSaver from 'file-saver';
import 'zone.js';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { bootstrapApplication } from '@angular/platform-browser';

import { MAT_DATE_LOCALE } from '@angular/material/core';

import { HttpClientModule } from '@angular/common/http';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { JwtHttpInterceptor } from './services/jwt-interceptor';
import { TenantClientInfoInterceptor } from './interceptors/tenant-client-info.interceptor';
import { ErrorInterceptor } from './interceptors/error.interceptor';
import { AppHttpInterceptor } from './interceptors/app-http.interceptor';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule, provideNoopAnimations } from '@angular/platform-browser/animations';
import { DatePipe } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';


import { ErrorService } from './services/error.service';
import { SupportService } from './services/support.service';
import { SdmUtilService } from './services/sdm-util.service';
import { PermissionService } from './services/permission.service';

import { ContentService } from './services/content.service';
import { UiHelperService } from './services/ui-helper.service';
import { NavigationUtilService } from './services/navigation-util.service';
import { AppLifecycleService } from './services/app-lifecycle.service';
import { StateTrackingService } from './services/state-tracking.service';
import { BodyClassService } from './services/body-class.service';
import { Auth0Service } from './services/auth0.service';
import { Auth0LockService } from './services/auth0-lock.service';
import { PreviousRouteService } from './services/previous-route-service';
import { Auth0Guard } from './guards/auth0.guard';
import { AuthTransitionService } from './services/auth-transition.service';
import { Auth0JwtInterceptor } from './interceptors/auth0-jwt.interceptor';
import { AuthModule } from '@auth0/auth0-angular';
import { RouterModule, Router, RouterOutlet } from '@angular/router';
import { AppRoutingModule } from './routing/app-routing.module';
import { UserNotificationPreferencesComponent } from './components/user-notification-preferences/user-notification-preferences.component';
import { ConfirmDialogComponent } from './components/shared/confirm-dialog/confirm-dialog.component';
import { GlobalMainComponent } from './components/global-admin/global-main/global-main.component';
import { GlobalAlarmComponent } from './components/global-admin/global-alarm/global-alarm.component';
import { GlobalSetCurrentTenantComponent } from './components/global-admin/global-set-current-tenant/global-set-current-tenant.component';
import { GlobalUnitComponent } from './components/global-admin/global-unit/global-unit.component';
import { MainComponent } from './components/main/main.component';
import { AlarmComponent } from './components/alarm/alarm.component';
import { LocationComponent } from './components/location/location.component';
import { UnitOverviewComponent } from './components/unit-overview/unit-overview.component';
import { LocationUnitAnchoringComponent } from './components/location-unit-anchoring/location-unit-anchoring.component';
import { AppRootComponent } from './components/app-root/app-root.component';
import { TopMenuComponent } from './components/top-menu/top-menu.component';
import { ContentPipe } from './pipes/content.pipe';
import { SdmPermissionDirective } from './directives/sdmpermission.directive';
import { OnEnterDirective } from './directives/on-enter.directive';
import { OnEscapeDirective } from './directives/on-escape.directive';




@NgModule({
	imports: [
		BrowserModule,
		CommonModule,
		HttpClientModule,
		FormsModule,
		BrowserAnimationsModule,
		MatDialogModule,
		MatSnackBarModule,
		MatButtonModule,
		MatCardModule,
		MatIconModule,
		AppRoutingModule,
		AuthModule.forRoot(Auth0Service.getAuth0Config()),
		
		ContentPipe,
		SdmPermissionDirective,
		OnEnterDirective,
		OnEscapeDirective,
		MainComponent,
		TopMenuComponent,
		AlarmComponent
	],
	declarations: [
		AppRootComponent
		
	],
	schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
	providers: [
		{ provide: HTTP_INTERCEPTORS, useClass: JwtHttpInterceptor, multi: true },
		{ provide: HTTP_INTERCEPTORS, useClass: TenantClientInfoInterceptor, multi: true },
		{ provide: HTTP_INTERCEPTORS, useClass: AppHttpInterceptor, multi: true },
		{ provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
		{ provide: MAT_DATE_LOCALE, useValue: 'en-CA' },
		DatePipe,
		PermissionService,
		NavigationUtilService,
		AppLifecycleService,
		StateTrackingService,
		BodyClassService,
		Auth0Service,
		Auth0LockService,
		Auth0Guard,
		AuthTransitionService,
		PreviousRouteService
	],
	bootstrap: [AppRootComponent], 
})

export class AppModule {
	// No custom bootstrap needed
}

platformBrowserDynamic().bootstrapModule(AppModule);